import { color } from '../../../lib/Theme/Theme';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  bottomBorder: {
    borderBottom: `2px solid ${color.borderBottom}`,
  },
});
